// 正常业务事件不绑定设备类型，使用当前拓扑中的两个不同节点。
function trafficEvent(name, describe) {
  return {
    name,
    text: describe('A', 'C'),
    resolveText(nodes = []) {
      const ids = [...new Set(nodes
        .filter((node) => node && node.id != null && String(node.id).trim())
        .map((node) => String(node.id)))]
      const [source, target] = ids
      // 节点不足时保留可编辑占位符，不捏造当前拓扑中的实体。
      return describe(source || 'A', target || 'C')
    }
  }
}

// 预设演化事件：正常业务行为、故障与恢复，以及全网节点批量检测。
export const PRESET_EVENTS = [
  trafficEvent('正常业务 · 突发传输 10 GB 数据', (source, target) =>
    `节点 ${source} 向节点 ${target} 发起一次总量 10 GB（十进制，80 Gb）的数据传输，期望在 600 秒内完成，平均有效载荷速率需求约 133.33 Mbps，协议开销另计。这是正常业务请求，不预设设备故障。请根据实际可达路径、链路剩余带宽和现有负载推演吞吐量、排队、时延及能否按时完成；带宽不足时说明瓶颈，不将 10 GB 当作 10 Gbps，也不假设传输已经完成。`),
  trafficEvent('正常业务 · 视频传输', (source, target) =>
    `节点 ${source} 开始向节点 ${target} 持续传输视频，新增带宽需求为 20 Mbps，持续 300 秒，其余业务保持不变。请推演可达路径、链路利用率和视频传输时延，不预设发生故障。`),
  trafficEvent('正常业务 · 状态数据上报', (source, target) =>
    `节点 ${source} 向节点 ${target} 周期上报运行状态和业务指标，每秒发送一次，每次有效载荷 10 KB（十进制），持续 600 秒，平均新增速率为 80 kbps。请评估这项正常状态上报业务对现有网络的影响，不预设故障。`),
  trafficEvent('正常业务 · 数据同步', (source, target) =>
    `节点 ${source} 向节点 ${target} 同步 500 MB（十进制）的业务数据，发送速率上限为 10 Mbps，允许按实际可用带宽降低速率，其他业务保持不变。请估计完成时间及对既有业务的影响，不预设设备故障。`),
  trafficEvent('正常业务 · 控制指令下发', (source, target) =>
    `节点 ${source} 向节点 ${target} 下发控制指令，每秒 10 条，每条有效载荷 1 KB（十进制），持续 60 秒，平均新增速率为 80 kbps，期望端到端时延不超过 100 ms。请根据现有路径和负载评估能否满足要求，不假设已有优先级调度或故障。`),
  trafficEvent('正常业务 · 视频码率降低', (source, target) =>
    `节点 ${source} 向节点 ${target} 的视频业务将带宽需求从 20 Mbps 降低至 5 Mbps，其他业务不变。若当前拓扑或业务信息中未记录该视频流，请明确将其作为场景假设，不虚构已存在的流 ID。请推演带宽释放后的利用率、排队与时延，不直接假定拥塞一定消失。`),
  trafficEvent('正常业务 · 数据传输结束', (source, target) =>
    `节点 ${source} 向节点 ${target} 的一项带宽需求为 10 Mbps 的数据同步业务结束，停止为该业务注入新流量，其他业务继续运行，已有队列仍需排空。若未记录该业务，请明确将其作为场景假设。请推演后续负载和排队变化，不把业务结束解释为节点或信道离线。`),
  { name: '节点故障', text: '如果 N0011 发生故障' },
  { name: '节点恢复', text: '如果 N0011 恢复正常' },
  { name: '信道故障', text: '如果信道 C0006 发生故障' },
  { name: '信道恢复', text: '如果信道 C0006 恢复正常' },
  { name: '网卡故障', text: '如果网卡 N0011:IF000002 发生故障' },
  { name: '网卡恢复', text: '如果网卡 N0011:IF000002 恢复正常' },
  { name: '数据流带宽变化', text: '如果数据流 F000023 的带宽需求变为 200 Mbps' },
  { name: '新增数据流', text: '新增一条从 N0011 到 UE0001 的数据流，带宽需求为 50 Mbps' },
  { name: '全网节点状态检测', allNodes: true, template: (nodeId) => `${nodeId} 当前的状态是什么？` }
]

